import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ControllerStatusService } from 'src/app/services/controller-status.service';
import { ApiUsuarioService } from '../services/api-usuario.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { map, take, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthMulticalculoGuard  {
  constructor(private controllerStatus: ControllerStatusService, private apiUsuario: ApiUsuarioService, private router: Router, private snack: MatSnackBar) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.verificaAcessosMulticalculo(state.url);
  }

  private async verificaAcessosMulticalculo(url) {
    let urlCopy:any = url;
    let status = this.verificaStatus();    
    let newUrl = url.split('?');

    if (!status) {
      let temPermissao;
      if (this.apiUsuario.grupoPermissoesUsuario() && this.apiUsuario.permissoesCorretora.length > 0) {
        temPermissao = this.controllerStatus.verificaPermissoes(newUrl.length > 1 ? newUrl[0] : url);
      }
  
      temPermissao = await this.apiUsuario.permissoesCarregadas$.pipe(
        filter(carregou => carregou),
        take(1),
        map(() => this.controllerStatus.verificaPermissoes(newUrl.length > 1 ? newUrl[0] : url))
      ).toPromise();

      if(temPermissao === false) {
        this.router.navigate(['/meu-plano']);
        this.snack.open('Recurso não disponível no seu plano atual. Atualize seu plano para ter acesso a esta funcionalidade','Ok', {
          duration: 6000,
        });
        return false;
      } else {
        return true;
      }

    } else {
      return true
    }

  }  

  private verificaStatus() {
    let result : any = this.apiUsuario.verificaLicenca();
    if (result?.prazoHoras >= 0 && !result.periodoTeste) {
      return false;
    }

    return true;
  }
  
}